import React from "react";

const Bash_Touch = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Touch</h2>
      <p>Create an empty file or update the timestamp.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>touch file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>touch newfile.txt
touch -t 202501010101 file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Useful in Makefile workflows.</p>
    </div>
  );
};

export default Bash_Touch;
